export const skillsList = [
    "Semantic & accessible HTML",
    "Responsive Web Design",
    "Markdown",
    "BEM convention",
    "CSS Grid",
    "CSS Flexbox",
    "JavaScript: ES6+",
    "Immutability",
    "React",
    "React Hooks",
    "React Router",
    "Redux (Toolkit)",
    "Redux Saga",
    "React-hook-form",
    "Reac-query",
    "Working with API (fetch, axios)",
    "Promises, Async/Await",
    "Error handling",
    "NPM",
    "Yarn",
    "GitHub Pull Requests & Review",
    "Git",
    "Trello",
    "Scrum",
    "Safe",
    "Agile",
    "Vue 2",
    "Vue 3",
    "Vuex",
    "Pinia",
    "Vue Router",
    "Typescript",
    "Bootstrap",
    "Sass",
    "Material UI",
];